import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Section965AdjsComponent } from './components/section-965-adjs/section-965-adjs.component';
import { Section965FgComponent } from './components/section-965-fg/section-965-fg.component';
import { Section965NovDecComponent } from './components/section-965-nov-dec/section-965-nov-dec.component';
import { Section9651231Component } from './components/section-965-12-31/section-965-12-31.component';
import { Section965TaxDbComponent } from './components/section-965-tax-db/section-965-tax-db.component';

@NgModule({
  declarations: [
    Section965AdjsComponent,
    Section965FgComponent,
    Section965NovDecComponent,
    Section9651231Component,
    Section965TaxDbComponent
  ],
  imports: [
    CommonModule,
    FormsModule
  ],
  exports: [
    Section965AdjsComponent,
    Section965FgComponent,
    Section965NovDecComponent,
    Section9651231Component,
    Section965TaxDbComponent
  ]
})
export class Section965Module { }
